"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=booking-channel.dto.js.map